import { formatearFecha, validarRangoFechas } from '../../../helpers/dateValidation'

export const MAX_LENGTH_NOMBRE_LISTA = 27

export const buildListaVentaInitialValues = () => ({
  nombre: '',
  vigenciaDesde: formatearFecha(new Date(), 'YYYY-MM-DD'),
  vigenciaHasta: ''
})

export const validateListaVentaForm = ({
  values,
  listas = [],
  editMode = false,
  currentId = null,
  minNombreLength = 0
}) => {
  const errores = {}
  const nombre = (values.nombre || '').trim()

  if (!nombre) {
    errores.nombre = 'El nombre de la lista es obligatorio.'
  } else if (minNombreLength > 0 && nombre.length < minNombreLength) {
    errores.nombre = `El nombre debe contener al menos ${minNombreLength} caracteres.`
  } else {
    const nombreNormalizado = nombre.toLowerCase()
    const existe = listas.some((l) => {
      const label = (l.label || l.nombre || '').toLowerCase().trim()
      if (!editMode) {
        return label === nombreNormalizado
      }
      const idLista = l.value ?? l.idListaVenta
      return label === nombreNormalizado && Number(idLista) !== Number(currentId)
    })

    if (existe) {
      errores.nombre = 'Ya existe una lista con ese nombre.'
    }
  }

  if (!values.vigenciaDesde) {
    errores.vigenciaDesde = 'La fecha de inicio de vigencia es obligatoria.'
  } else if (!validarRangoFechas(new Date(), values.vigenciaDesde, 'day')) {
    errores.vigenciaDesde = 'La fecha de vigencia desde no puede ser menor a hoy.'
  }

  if (!values.vigenciaHasta) {
    errores.vigenciaHasta = 'La fecha de fin de vigencia es obligatoria.'
  } else if (!validarRangoFechas(values.vigenciaDesde, values.vigenciaHasta, 'day')) {
    errores.vigenciaHasta = 'La fecha de fin de vigencia debe ser mayor o igual que la de inicio.'
  }

  return errores
}
